import { getNestedProperty } from '@opallabs/lambda'
import type { AssignmentsResponse } from './types'

const relationshipIdByEntity = (entity: string): string[] => [
  'relationships',
  entity,
  'data',
  'id',
]

export const getMomentIdsFromAssignmentsResponse = (
  assignmentsResponse: AssignmentsResponse
): string[] => {
  const assignments = assignmentsResponse.data.data
  const included = assignmentsResponse.data.included || []
  return assignments
    .map((assignment) => {
      const stageId = getNestedProperty<string>(
        assignment,
        ...relationshipIdByEntity('stage')
      )
      if (stageId !== undefined) {
        const stage = included.find(
          (include) => include.id === stageId && include.type === 'stage'
        )
        if (stage !== undefined) {
          const workflowId = getNestedProperty<string>(
            stage,
            ...relationshipIdByEntity('workflow')
          )
          if (workflowId !== undefined) {
            const workflow = included.find(
              (include) =>
                include.id === workflowId && include.type === 'workflow'
            )
            if (workflow !== undefined) {
              const contextId = getNestedProperty<string>(
                workflow,
                ...relationshipIdByEntity('context')
              )
              if (contextId !== undefined) {
                const context = included.find(
                  (include) =>
                    include.id === contextId && include.type === 'context'
                )
                if (context !== undefined) {
                  const momentId = getNestedProperty<string>(
                    context,
                    ...relationshipIdByEntity('moment')
                  )
                  if (momentId !== undefined) {
                    return momentId
                  }
                }
              }
            }
          }
        }
      }
      return undefined
    })
    .filter((id): id is string => id !== undefined)
}
